module.exports = __webpack_public_path__ + "img/login.ce565299.png";